var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"proxy-bar"},[_c('global-alert',[_vm._v(" "+_vm._s(_vm.$t("proxied", { name: _vm.user.name }))+" "),_c('ebp-button',{staticClass:"ml-3",attrs:{"size":"sm"},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm.$t("back-to-admin")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }